import cx from 'classnames';
import React from 'react';

import { Icon, IconCopy, IconNewTab } from '@flixbus/honeycomb-icons-react';
import { Button } from '@flixbus/honeycomb-react';

import { LABELS } from '../labels';

import styles from './styles.module.css';

const RideItemsRow = ({ rideItems, isProblematic, onCopyRideId }) => {
	const ridesGridTemplateColumns = `repeat(${rideItems.length}, 1fr)`;

	const handleCopyRideId = (id) => {
		navigator.clipboard
			.writeText(id)
			.then(() => onCopyRideId?.())
			.catch(() => {});
	};

	return (
		<div className={styles.ridesWrap}>
			<div className={styles.ridesHeader}>{LABELS.rides}</div>
			<div
				className={styles.ridesRow}
				data-testid="rides-row"
				style={{ gridTemplateColumns: ridesGridTemplateColumns }}
			>
				{rideItems.map((item) => (
					<div
						key={item.key}
						className={cx(styles.rideChip, { [styles.problematic]: isProblematic })}
					>
						<div className={styles.rideText}>
							<div className={styles.rideTitle}>{item.title}</div>
							<div className={styles.rideSub}>{item.subtitle}</div>
						</div>
						<div className={styles.rideActions}>
							<Button
								size="sm"
								display="square"
								appearance="link"
								Elem="a"
								href={`/details/${item.id}`}
							>
								<Icon InlineIcon={IconNewTab} size={3} />
							</Button>
							<Button
								size="sm"
								display="square"
								appearance="link"
								onClick={() => handleCopyRideId(item.id)}
							>
								<Icon InlineIcon={IconCopy} size={3} />
							</Button>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default RideItemsRow;
